import { Injectable, EventEmitter } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})


export class EmployeeService {

  is_display_employee_register_component = false;
  employeeUpdate = new EventEmitter<ZONE>();

  downloadEmployee = new EventEmitter<boolean>();

  private _employee_data: EMPLOYEE = null;

  constructor() { }

  set set_employee_data(employee) {
    this._employee_data = employee;
  }

  get get_employee_data() {
    return this._employee_data;
  }

}


export interface EMPLOYEE {
  id: number;
  name: string;
}